// 🔥 Firebase App Check Configuration
// This file manages App Check setup and ReCaptcha configuration

export interface AppCheckConfig {
  recaptchaSiteKey: string;
  debugToken?: string;
  isDevelopment: boolean;
}

// reCAPTCHA v3 site key. On staging, App Check is unenforced — no v3 key exists yet for
// kb-staging-proj, so VITE_RECAPTCHA_SITE_KEY must be set explicitly or App Check is skipped.
const _isStaging = import.meta.env.VITE_FIREBASE_ENV === 'staging';
const RECAPTCHA_SITE_KEY = import.meta.env.VITE_RECAPTCHA_SITE_KEY || (_isStaging ? '' : '6LfB-norAAAAACBNJdRPVemreylX5RVLBhPR70G1');

// Debug token for development (optional)
const DEBUG_TOKEN = import.meta.env.VITE_FIREBASE_APPCHECK_DEBUG_TOKEN;

// 🔥 FORCE PRODUCTION MODE - NO DEBUG TOKENS
const isDevelopment = false; // Always production mode

export const appCheckConfig: AppCheckConfig = {
  recaptchaSiteKey: RECAPTCHA_SITE_KEY,
  debugToken: undefined, // Never use debug tokens
  isDevelopment: isDevelopment
};

// 🔥 Configuration validation
if (!appCheckConfig.recaptchaSiteKey) {
  if (_isStaging) {
    console.log('[AppCheck] No reCAPTCHA site key on staging — App Check will be skipped (unenforced)');
  } else {
    console.error('[AppCheck] ReCaptcha site key is required');
  }
}

console.log('[AppCheck] Configuration loaded:');
console.log('[AppCheck] - ReCaptcha site key:', appCheckConfig.recaptchaSiteKey ? appCheckConfig.recaptchaSiteKey.substring(0, 20) + '...' : '(none — staging, App Check skipped)');
console.log('[AppCheck] - Development mode:', appCheckConfig.isDevelopment);
console.log('[AppCheck] - Debug tokens:', 'DISABLED'); 